var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnosisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 143,
    viewBox: "0 0 144 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.755 81.2519C47.0026 81.2519 50.9236 79.8405 54.0824 77.3975L28.1599 51.556C25.7092 54.6506 24.2932 58.5593 24.2932 62.8482C24.2388 73 32.5166 81.2519 42.755 81.2519Z",
    fill: "#04795B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.869 62.7936C119.869 58.5593 118.453 54.6506 116.002 51.5017L90.0796 77.3429C93.184 79.7859 97.105 81.1973 101.407 81.1973C111.591 81.2516 119.869 73 119.869 62.7936V62.7936Z",
    fill: "#04795B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.939 34.7269L121.448 46.1819C125.26 50.7419 127.548 56.4965 127.548 62.9028C127.548 77.2889 115.839 88.961 101.407 88.961C95.0355 88.961 89.2083 86.6809 84.6339 82.8808L72.0537 95.4213L59.4736 82.8808C54.8991 86.6809 49.1264 88.961 42.7002 88.961C28.2684 88.961 16.5597 77.2889 16.5597 62.9028C16.5597 56.5508 18.8471 50.7419 22.6593 46.1819L16.7777 40.3187L11.1683 34.7269C4.63327 45.476 0.875488 58.0168 0.875488 71.4803C0.875488 110.676 32.734 142.381 71.9993 142.381C111.264 142.381 143.123 110.622 143.123 71.4803C143.232 57.9626 139.474 45.4218 132.939 34.7269V34.7269Z",
    fill: "#04795B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.518 22.5117C110.611 8.99398 92.3125 0.525024 72.0539 0.525024C51.7949 0.525024 33.5512 8.99398 20.5898 22.5117C18.8472 24.3577 17.1591 26.3122 15.5796 28.3207L71.9994 84.5633L128.419 28.2664C127.003 26.3119 125.315 24.3034 123.518 22.5117V22.5117ZM72.0539 9.75404C88.7183 9.75404 104.185 16.1601 115.784 27.8322L72.0539 71.4257L28.323 27.8322C39.9773 16.1601 55.3894 9.75404 72.0539 9.75404Z",
    fill: "#04795B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosisIcon);
export default __webpack_public_path__ + "static/media/gnosis_icon.ca06416a91a39a1226e1e3945b036fa8.svg";
export { ForwardRef as ReactComponent };